module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch3_20210921122649_T.3f2c0822.jpg";